var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9996 12.2304V14.4885C15.0004 14.6981 14.9602 14.9056 14.8817 15.0977C14.8031 15.2898 14.6879 15.4622 14.5435 15.6039C14.399 15.7456 14.2285 15.8535 14.0428 15.9207C13.8571 15.9878 13.6603 16.0128 13.465 15.9939C11.299 15.7422 9.2183 14.9508 7.39023 13.6831C5.68945 12.5274 4.24748 10.9855 3.16674 9.16689C1.9771 7.20324 1.23677 4.96756 1.00571 2.64096C0.988123 2.43282 1.01126 2.22303 1.07364 2.02497C1.13603 1.82691 1.2363 1.6449 1.36807 1.49055C1.49984 1.33619 1.66022 1.21287 1.839 1.12843C2.01779 1.04398 2.21106 1.00027 2.40651 1.00007H4.51826C4.85987 0.996478 5.19105 1.12583 5.45007 1.36403C5.70909 1.60222 5.87828 1.93301 5.92609 2.29472C6.01522 3.01736 6.18052 3.72691 6.41883 4.40981C6.51354 4.67922 6.53403 4.97202 6.47789 5.2535C6.42175 5.53498 6.29132 5.79336 6.10207 5.99801L5.20809 6.95394C6.21016 8.83837 7.6693 10.3986 9.43159 11.4702L10.3256 10.5142C10.517 10.3118 10.7586 10.1724 11.0218 10.1123C11.2851 10.0523 11.5589 10.0742 11.8108 10.1755C12.4495 10.4303 13.113 10.6071 13.7888 10.7024C14.1308 10.754 14.4431 10.9381 14.6663 11.2199C14.8895 11.5016 15.0081 11.8612 14.9996 12.2304Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.f6c4e083b02ddd1cb7925668cae2a0b6.svg";
export { ForwardRef as ReactComponent };